<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">Edit Photo</div>
  </div>
  <div class="card-body">
    <div class="container">
      <div class="row">
        <div class="col-lg-8" style="min-height: 300px">
          <image-cropper
            [imageChangedEvent]="imageChangedEvent"
            [imageBase64]="base64String"
            [maintainAspectRatio]="true"
            [aspectRatio]="1 / 1"
            format="png"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded()"
            (cropperReady)="cropperReady()"
            (loadImageFailed)="loadImageFailed()"
            [roundCropper]="true"
            [disabled]="!editable"
          ></image-cropper>
        </div>
        <div class="col-lg-4">
          <table style="margin: auto">
            <tr>
              <td style="text-align: left; border-bottom: 1px solid lightgrey">
                <h5>Preview</h5>
              </td>
            </tr>
            <tr>
              <td style="text-align: center; padding-top: 15px">
                <img
                  [hidden]="!loading"
                  style="max-width: 120px; border-radius: 50%; box-shadow: 0 0 4px rgb(0 0 0 / 42%)"
                  [src]="croppedImage"
                />
              </td>
            </tr>
            <tr>
              <td style="text-align: center; padding-top: 20px">
                <img
                  [hidden]="!loading"
                  style="max-width: 40px; border-radius: 50%; box-shadow: 0 0 4px rgb(0 0 0 / 42%)"
                  [src]="croppedImage"
                />
              </td>
            </tr>
            <tr>
              <td style="text-align: center; padding-top: 20px">
                <img
                  [hidden]="!loading"
                  style="max-width: 26px; border-radius: 50%; box-shadow: 0 0 4px rgb(0 0 0 / 42%)"
                  [src]="croppedImage"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8" style="text-align: center">
          <a
            class="btn btn-secondary"
            style="padding: 5px; font-weight: 600"
            (click)="uploader.click()"
            >{{ editable ? 'Change' : 'Upload' }} Photo
            <input
              hidden
              #uploader
              type="file"
              name="profile_avatar"
              accept=".png, .jpg, .jpeg"
              (change)="imageChanged($event)"
            />
          </a>
          &nbsp;
          <a
            *ngIf="editable"
            class="btn btn-outline-secondary"
            style="padding: 5px"
            (click)="RemovePicture()"
          >
            <span class="svg-icon svg-icon-md svg-icon-secondary" style="margin: 0">
              <span inlineSVG="./assets/media/svg/icons/General/delete_icon.svg"></span>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button class="mr-2" mat-raised-button color="primary" (click)="save()">Save</button>
        <button mat-button mat-dialog-close>Cancel</button>
      </div>
    </div>
  </div>
</div>
